export default __webpack_public_path__ + "static/media/healthcdb.61ab4d67.jpg";